<template>
    <div id="page">
        <div class="page-content">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2>
                        <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                        چارت سازمانی
                        <!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-3">
                    <div class="p-3">
                        <div class="w-100 search-box rounded-m position-relative">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                        </div>
                    </div>
                </div>
            </div>

            <span data-menu="menu-language" class="optionMenu"></span>

            <div class="main-content-box-2">
                <div class="card card-style">
                    <div class="content mb-0">
                        <div class="list-group list-custom-small list-icon-0">
                            <div class="list-group-div" @click.prevent="openDetails(task.orgJobId)" v-for="task in OrgJobList" :key="task.orgJobId">
                                <div class="py-3">
                                    <i class="fa fa-sitemap brand-color"></i>
                                    <b class="text-muted">{{task.code}} - {{task.title}}</b>
                                    <span @click.stop="showMenu(task)" width="60px"><i class="fa fa-ellipsis-v float-left ml-0"></i></span>
                                </div>
                            </div>

                            <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                                <div class="spinner-border color-magenta2-dark" role="status"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
        <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
            <router-link to="/CreateOrgJob">
                <div class="icon icon-m rounded-m color-white bg-green2-light">
                    <i class="fa fa-plus"></i>
                </div>
            </router-link>
        </div>
    </transition>-->

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <a href="#" @click="openCreatePage()" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-plus color-green2-light float-right font-14"></i>افزودن</span><i class="fa fa-angle-left"></i></a>

                    <router-link :to="{ name: 'EditOrgJob', params: { orgJobId: selectedTypeId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <a href="#" @click="deleteOrgJob" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></a>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList"  v-if="isKarnegasht==true"></Help-Menu>

    </div>
</template>

<script>
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedTypeId: 0,
                selectedOrgJob: null,
                pageLoaded: false
            };
        },
        computed: {
            OrgJobList() {
                return this.$store.getters.GetOrgJobList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },

        created() {

            this.$store.dispatch("GetOrgJobListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
            openCreatePage() {
                if (this.selectedOrgJob.FinalLevel == "1") {
                    this.showErrorMessage("افزودن زیر سطح برای این بخش سازمانی امکان پذیر نمی باشد.");
                }
                this.$router.push({ name: 'CreateOrgJob', params: { parentId: this.selectedTypeId } });
            },
            showMenu(orgJob) {
                this.selectedTypeId = orgJob.orgJobId;
                document.getElementsByClassName("optionMenu")[0].click();
                this.selectedOrgJob = orgJob;
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetOrgJobListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            deleteOrgJob() {
                document.getElementsByClassName("menu-hider")[0].click();

                if (this.selectedOrgJob.levelId == 1) {
                    this.showErrorMessage("حذف سطح اصلی امکان پذیر نمی باشد.")
                    return;
                }
                VueSimpleAlert.confirm("آیا مایل به حذف این پست سازمانی هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("OrgUnit/DeleteOrgJob?id=" + this.selectedTypeId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res == "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.$router.go();
                            }
                            else {
                                this.showErrorMessage(res);
                            }
                        });
                });
            },
            openDetails(orgJobId) {
                this.$router.push({ name: 'EditOrgJob', params: { orgJobId: orgJobId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForOrgJobList() {
                this.page++;
                this.$store.dispatch("GetOrgJobListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

            console.log("mounted");
            this.getNextPageForOrgJobList();
        }
    };
</script>
